import { PropsWithChildren } from 'react'
import css from './sheet.module.css'

const Sheet = (props: PropsWithChildren) => {
  return <div className={css.wrapper}>{props.children}</div>
}

export default Sheet
